/**
 * Computes the percent_off values from the coupons in a given receipt object.
 * @param {Object} receiptObject
 * @returns {int}
 */

const getCouponDiscount = (receiptObject) => {
  const discountCoupons = receiptObject.coupons.filter((coupon) => coupon.type === "discount");
  const totalPercentOff = discountCoupons
    .map((coupon) => coupon.percent_off)
    .reduce((partialSum, a) => partialSum + a, 0);

  return totalPercentOff;
};

/**
 * Returns the tax rate provided the receipt object has a non-Inclusive tax type
 * @param {Object} receiptObject
 * @returns {int}
 */

const getTaxRate = (receiptObject) => {
  let taxRate = 0;
  if (receiptObject.tax.type === "exclusive") {
    taxRate = receiptObject.tax.rate;
  }
  return taxRate;
};

/**
 * Computes the total fare of a given ride
 * @param {Object} receiptObject
 * @param {int} time (In Minutes)
 * @returns {Object}
 */

export default (receiptObject, rideDuration) => {
  let fareObject = {
    taxRate: 0,
    coupon: 0,
    ratePlan: 0,
    amountCharged: 0,
  };
  const taxRate = getTaxRate(receiptObject);
  const coupons = getCouponDiscount(receiptObject);

  const ratePlanFee = receiptObject.rate_plan.time_unit_fee / 100;
  const ratePlanFare = rideDuration * ratePlanFee * (1 - coupons / 100);
  const totalFare = ratePlanFare + ratePlanFare * (taxRate / 100);

  fareObject = {
    taxRate,
    couponDiscount: coupons,
    ratePlan: ratePlanFee,
    amountCharged: totalFare,
    filledTextReadyAmount: Math.round(totalFare * 100).toString(),
  };
  return fareObject;
};
